import React from 'react';
import styles from './FloActionSelector.module.css';
import { FloComponentProps } from 'components';
import classnames from 'classnames';
import { Dropdown } from 'react-bootstrap';
import { FloTableActions } from './model';

export interface FloActionSelectorProps extends FloComponentProps {
  actions: FloTableActions;
  keyValue:  string;
}

export const FloActionSelector: React.FC<FloActionSelectorProps> = ({className, actions, keyValue}) => {
  return (
    <Dropdown
      className={classnames(
        styles.root,
        className
      )}
      drop="left"
    >
      <Dropdown.Toggle
        as="span"
        id="flo-action-selector"
      >
        <svg width="7" height="5" viewBox="0 0 5 5" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="2.5" cy="2.5" r="2.5" fill="#9DADB9"/>
        </svg>
        <svg width="7" height="5" viewBox="0 0 5 5" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="2.5" cy="2.5" r="2.5" fill="#9DADB9"/>
        </svg>
        <svg width="7" height="5" viewBox="0 0 5 5" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="2.5" cy="2.5" r="2.5" fill="#9DADB9"/>
        </svg>
      </Dropdown.Toggle>

      <Dropdown.Menu className={styles.menu}>
        { actions.map(action =>
          (('show' in action ? (typeof action.show === 'function' ? action.show(keyValue) : action.show) : true) && <Dropdown.Item
            key       = {`flo-action-selector-${action.id}`}
            onClick   = {(event: any) => action.onClick(keyValue)}
            className = {styles.item}
            disabled  = {typeof action.disabled === 'function' ? action.disabled(keyValue) : action.disabled}
          >
            {action.text}
          </Dropdown.Item>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default FloActionSelector;
